export const state = {
  cargoentries: [],
  systemCargo: [],
  cargos: [
    {
      container_no: '',
      cargo_size: '',
      weight_units: '',
      net_weight: '',
    }
  ],
  systemCargofile: [],
  fileopeningcargos: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/cargoentries/state.js